// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Offline_pageWrapper__Vmmtf","imgWrapper":"Offline_imgWrapper__esrIJ","title":"Offline_title__k09fW","subtitle":"Offline_subtitle__ZumZc"};